import type { UtmMetricDto } from '@/api/backend/users/applications';

export const hasUtmValues = (metrics?: UtmMetricDto): boolean =>
  Object.values(metrics ?? {}).some((value) => typeof value === 'string' && value.trim() !== '');
